// extracted by mini-css-extract-plugin
module.exports = {"buttonLabelSm":"ShrinkingButtonGroup_buttonLabelSm__1Kkkw","popper":"ShrinkingButtonGroup_popper__2UFqZ","buttonLabelLg":"ShrinkingButtonGroup_buttonLabelLg__3RKBM"};